import { Repeater } from "./interfaces";

export class MultiLocationController {
    constructor(
        private repeater: Repeater
    ){}

    init(): void {
        this.repeater.addItem();
    }

    generateExistingItems(repeaterButtonContainer: HTMLButtonElement, locations: [] ): void {
        if ( !repeaterButtonContainer) {
            console.warn('Repeater button container not found');
            return;
        }

        this.repeater.generateItems(repeaterButtonContainer, locations);
    }
}